import React from "react";

type Props = {
  pageIndex: number;
  pageCount: number;
  onPrev: () => void;
  onNext: () => void;
  isFetching?: boolean;
};

const SimplePagination = (props: Props) => {
  const { pageIndex, pageCount, onPrev, onNext, isFetching } = props;

  return (
    <div className="anys-moderation-page__pagination">
      <button onClick={onPrev} disabled={pageIndex <= 0}>
        {"<"}
      </button>
      <span>
        Page <strong>{pageIndex + 1}</strong> of {Math.max(pageCount, 1)}
      </span>
      <button onClick={onNext} disabled={pageIndex + 1 >= pageCount}>
        {">"}
      </button>
      {isFetching ? <span>Loading…</span> : null}
    </div>
  );
};

export default SimplePagination;
